import React, { useMemo } from "react"; // Import useMemo, removed useState and useEffect
import { Container, Row, Col } from "react-bootstrap";
import {
  VictoryLine,
  VictoryChart,
  VictoryScatter,
  VictoryAxis,
  VictoryTheme,
  // Removed VictoryBar, VictoryZoomContainer, VictoryBrushContainer as they were unused
} from "victory";

import { BsCircleFill } from "react-icons/bs";

import empty from "../../Assets/DWML/emptybox.gif";
import rocket from "../../Assets/DWML/rocket.gif";
import moon from "../../Assets/DWML/moon.gif";

function Result(props) {
  // Removed unused selectedDomain, zoomDomain states and handleZoom, handleBrush functions

  const imageSrc = useMemo(() => {
    if (props.NumberLambos === undefined || props.NumberLambos === null) {
        return empty; // Default to empty if NumberLambos is not provided
    }
    const numLambos = Math.floor(props.NumberLambos);
    if (numLambos >= 10) {
      return moon;
    } else if (numLambos < 10 && numLambos >= 1) {
      return rocket;
    } else {
      return empty;
    }
  }, [props.NumberLambos]);

  // Memoize the parsing and transformation of graph data
  const processedGraphData = useMemo(() => {
    if (!props.GraphData) {
      // console.warn("GraphData prop is missing or empty."); // Optional warning
      return [];
    }
    try {
      const rawData = JSON.parse(props.GraphData);
      if (!Array.isArray(rawData)) {
        // console.error("Parsed GraphData is not an array."); // Optional error logging
        return [];
      }
      return rawData.map((item) => ({
        x: new Date(Date.parse(item.x)),
        y: parseFloat(item.y),
      }));
    } catch (error) {
      console.error("Failed to parse GraphData:", error);
      return []; // Return empty array on error to prevent chart crashing
    }
  }, [props.GraphData]);

  // Data for VictoryLine, derived from processedGraphData
  const lineChartData = useMemo(() => {
    return processedGraphData;
  }, [processedGraphData]);

  // Data for VictoryScatter, finding the point with the highest 'y' value
  const scatterChartData = useMemo(() => {
    if (!processedGraphData || processedGraphData.length === 0) {
      return [];
    }

    // Find the data point with the maximum y value
    // Initialize maxPoint with the first element, ensuring it has a valid structure
    const maxPoint = processedGraphData.reduce(
        (max, current) => (current.y > max.y ? current : max),
        processedGraphData[0] // Initial value for reduce
    );
    
    return [maxPoint]; // VictoryScatter expects an array of data points
  }, [processedGraphData]);

  // createDateTickData function was removed as it was redundant;
  // VictoryAxis with scale="time" handles time ticks automatically.

  return (
    <Row style={{ justifyContent: "center", paddingBottom: "10px" }}>
      <Col md={12} className="project-card">
        <div className="image-container">
          <img src={imageSrc} width={250} height={250} alt="logo" />
        </div>
      </Col>

      <Col md={12} className="project-card">
        <h5>Number of Lambos</h5>
        <h6>{props.NumberLambos}</h6>
      </Col>

      <Col md={6} className="project-card">
        <h5>Initial Coins Bought</h5>
        <h6>{props.initialCoins}</h6>
      </Col>

      <Col md={6} className="project-card">
        <h5>Net profit</h5>
        <h6>$ {props.NetProfit}</h6>
      </Col>

      <Col md={6} className="project-card">
        <h5>Growth Factor</h5>
        <h6>X {props.GrowthFactor}</h6>
      </Col>

      <Col md={6} className="project-card">
        <h5>Initial Investment</h5>
        <h6>$ {props.InitialInvestment}</h6>
      </Col>

      <Col md={12} className="project-card">
        <h5>{props.coinSymbol} Performance</h5>
        {lineChartData.length > 0 ? ( // Conditionally render chart if data exists
          <VictoryChart
            padding={{ top: 50, bottom: 50, right: 10, left: 70 }} // Adjusted right padding
            scale={{ x: "time" }}
            theme={VictoryTheme.material}
            domainPadding={{ x: [10, 10], y: [0, 20] }} // Add some padding to domain
          >
            <VictoryAxis
              dependentAxis
              style={{
                grid: { stroke: "rgba(255, 255, 255, 0.3)", strokeWidth: 0.5 }, // Softer grid lines
                axisLabel: { fontSize: 10, padding: 35 },
                tickLabels: { fontSize: 8, padding: 5 }
              }}
              // tickFormat={(t) => `$${t.toFixed(2)}`} // Example y-axis tick formatting
            />

            <VictoryLine
              style={{
                data: { stroke: "#DA8C0B", strokeLinecap: "round", strokeWidth: 2 },
                // Removed parent border, usually handled by container styles
              }}
              animate={{
                onLoad: { duration: 2000 }, // Adjusted animation duration
              }}
              data={lineChartData}
            />

            {scatterChartData.length > 0 && ( // Only render scatter if data exists
              <VictoryScatter
                size={5} // Slightly larger for visibility
                style={{ data: { fill: "#236529" } }}
                data={scatterChartData}
                animate={{
                  onLoad: { duration: 2000 }, // Consistent animation duration
                }}
              />
            )}
            <VictoryAxis 
              fixLabelOverlap={true} 
              style={{
                axisLabel: { fontSize: 10, padding: 30 },
                tickLabels: { fontSize: 8, padding: 5, angle: -30, textAnchor: "end" } // Angled for better readability
              }}
              // tickFormat={(t) => new Date(t).toLocaleDateString()} // Example x-axis tick formatting
            />
          </VictoryChart>
        ) : (
          <p>No data available to display the chart.</p> // Fallback for no data
        )}
      </Col>

      <Col md={12} className="project-card">
        <div
          data-tip // Assuming react-tooltip or similar is used elsewhere
          data-for="global"
          style={{ display: "flex", justifyContent: "center", alignItems: "center" }}
        >
          <BsCircleFill size={"1rem"} style={{ color: "#236529" }} />
          <span style={{ paddingLeft: "10px" }}> {/* Reduced padding */}
            <h6>When you should have sold</h6>
          </span>
        </div>
      </Col>
    </Row>
  );
}

export default Result;